import React from 'react'

import { Button, Fieldset, HeadContent, Subsection, Table } from '@fourthwall/components'

import { CustomEmojiSkeleton } from './CustomEmojiSkeleton'
import { useCustomEmojiContext } from './hooks/useCustomEmojiContext'
import { CustomEmojiProvider } from './providers/CustomEmojiProvider'

const CustomEmojiContent = () => {
  const customEmoj = useCustomEmojiContext()

  if (customEmoj.isFetching) return <CustomEmojiSkeleton />

  return (
    <>
      <HeadContent title="Custom emoji" />
      <Subsection title="Custom emoji">
        <Fieldset>
          <Fieldset.Row>
            Bring personality to your memberships with custom emoji. Let your members express
            themselves in fun, unique ways by using emoji in comments on your posts.
          </Fieldset.Row>
          <Fieldset.Row>
            <Button
              label="Add custom emoji"
              appearance="primary"
              size="small"
              onClick={customEmoj.openCreateEmojiModal}
            />
          </Fieldset.Row>
          <Fieldset.Row>
            <div style={{ width: '100%' }}>
              <Table {...customEmoj.table} isLoading={customEmoj.isLoading} />
            </div>
          </Fieldset.Row>
        </Fieldset>
      </Subsection>
    </>
  )
}

export const CustomEmoji = () => (
  <CustomEmojiProvider>
    <CustomEmojiContent />
  </CustomEmojiProvider>
)
